module.exports = __webpack_public_path__ + "media/flags/gn-d57c8364.svg";